<template>
    <div
        :class="alertClasses"
        class="border-l-4 p-4">
        <div class="flex">
            <div class="shrink-0">
                <slot name="icon">
                    <Icon
                        :name="iconName"
                        size="5"
                        :text="iconClasses"
                        aria-hidden="true" />
                </slot>
            </div>
            <div class="ml-3 grow">
                <slot name="title">
                    <h3
                        :class="titleClasses"
                        class="text-sm font-semibold">
                        {{ title }}
                    </h3>
                </slot>
                <slot>
                    <BaseText
                        v-if="message"
                        :class="messageClasses"
                        class="mt-2">
                        {{ message }}
                    </BaseText>
                </slot>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    message: {
        type: String,
        default: ''
    },
    color: {
        type: String,
        default: 'warning'
    },
    icon: {
        type: String,
        default: null
    }
})

const iconName = computed(() => {
    if (props.icon) return props.icon
    switch (props.color) {
    case 'warning':
        return 'warning'
    case 'danger':
        return 'error'
    case 'success':
        return 'check'
    case 'primary':
        return 'check'
    default:
        return 'info'
    }
})

const alertClasses = computed(() => {
    switch (props.color) {
    case 'warning':
        return 'border-yellow-400 bg-yellow-50 text-yellow-800'
    case 'danger':
        return 'border-red-400 bg-red-50 text-red-800'
    case 'success':
        return 'border-green-400 bg-green-50 text-green-800'
    case 'primary':
        return 'border-primary-400 bg-primary-50 text-primary-800'
    default:
        return 'border-gray-400 bg-gray-50 text-gray-800'
    }
})

const iconClasses = computed(() => {
    switch (props.color) {
    case 'warning':
        return 'text-yellow-400'
    case 'danger':
        return 'text-red-400'
    case 'success':
        return 'text-green-400'
    case 'primary':
        return 'text-primary-400'
    default:
        return 'text-gray-400'
    }
})

const titleClasses = computed(() => {
    switch (props.color) {
    case 'warning':
        return 'text-yellow-800'
    case 'danger':
        return 'text-red-800'
    case 'success':
        return 'text-green-800'
    case 'primary':
        return 'text-primary-800'
    default:
        return 'text-gray-800'
    }
})

const messageClasses = computed(() => {
    switch (props.color) {
    case 'warning':
        return 'text-yellow-700'
    case 'danger':
        return 'text-red-700'
    case 'success':
        return 'text-green-700'
    case 'primary':
        return 'text-primary-700'
    default:
        return 'text-gray-700'
    }
})
</script>